import { useState } from 'react'

import { useContactpersoonFilterAccounts } from '../../../entity/contactpersonen/hooks/useContactpersoonFilterAccounts'
import type { AccountOption } from '../../../entity/contactpersonen/types/AccountOption'
import { SelectAccountOptions } from '../SelectAccount'

export { FilterContactpersoon }

interface Props {
  value: AccountOption | null
  onFilterChange: (filter: { contactpersoon: AccountOption | null }) => void
}

function FilterContactpersoon({ value, onFilterChange }: Props) {
  const [text, setText] = useState('')
  const { data: accounts } = useContactpersoonFilterAccounts({ text })

  return (
    <SelectAccountOptions
      label="Contactpersoon (account)"
      accounts={accounts}
      text={text}
      onSearch={setText}
      value={value}
      onChange={(contactpersoon) => onFilterChange({ contactpersoon })}
    />
  )
}
